export default "__VITE_ASSET__24279488__"